export enum ColorMode {
  LIGHT = 'light',
  DARK = 'dark'
}

export enum ColorModePreference {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system'
}
